var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1537_253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18152 0C1.42405 0 0 1.4232 0 3.17963V26.8462C0 28.6026 1.42405 30.0258 3.18152 30.0258H38.5065C40.264 30.0258 41.6881 28.6026 41.6881 26.8462V3.17963C41.6881 1.4232 40.264 0 38.5065 0H3.18152ZM15.0079 26.6911H3.32787V23.355H11.6711V20.0202H6.66592V16.6854H15.0079V26.6911ZM38.35 26.6911H18.3459V23.355H35.0132V20.0202H30.0577V16.6854H38.35V26.6911ZM26.67 16.6854V20.0202H18.3777V16.6752H21.7158V16.6854H26.67ZM26.6802 3.33479H35.0222V6.66958H30.017V10.0044H38.3602V13.3404H26.6802V3.33479V3.33479ZM15.018 3.33479H19.9723V3.32462H23.3103V6.66958H15.018V3.33479V3.33479ZM3.33805 3.33479H11.6304V6.66958H6.67482V10.0044H23.3422V13.3404H3.33805V3.33479V3.33479Z",
    fill: "url(#paint0_linear_1537_253)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1537_253",
    x1: 20.844,
    y1: 0,
    x2: 20.844,
    y2: 30.0259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89542"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1537_253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.6881,
    height: 30.0259,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoM);
export default __webpack_public_path__ + "static/media/logo-m.04919cc366ca686f971869b5c76676b9.svg";
export { ForwardRef as ReactComponent };